module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/redirect/redirect.component.html
// module id = ./src/app/pages/redirect/redirect.component.html
// module chunks = main